import cartIcon from "../../imgs/icon-cart.svg";
import "./Card.css"
export default function Card(props) {
    return (
        <div className="card">
            <div className="card-image">
                <img className="card-image-desktop" src={props.desktopImg} alt="Desktop" />
                <img className="card-image-mobile" src={props.mobileImg} alt="Mobile"/>
            </div>
            <div className="card-body">
                <h2 className="card-type">{props.type}</h2>
                <h1 className="card-title">{props.title}</h1>
                <p className="card-desc">{props.desc}</p>
                <div className="card-price">
                    <p className="card-price-discounted">{"$" + props.discountedPrice}</p>
                    <p className="card-price-normal">{"$" + props.normalPrice}</p>
                </div>
                <button href="#" className="card-button-add-cart">
                    <img src={cartIcon} alt="button" />
                    Add to cart
                </button>
            </div>
        </div>
    );
}